import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { checkCouponValidity, resetCouponCodeDetails } from "../../Actions/ValidationCouponActions/actions";
import { SuperAdminAction } from "../../Actions";
import DataTable from "react-data-table-component";
import moment from "moment";

function CheckCouponValidity(props) {
  const [coupon_code, setCoupon_code] = useState("");
  const [loader, setLoader] = useState(false);
  const couponValidationDetail = useSelector((state) => state.ValidationDetails.couponValidationDetail);
  const UserData = useSelector((userState) => userState.UserProfileDetails);
  const dispatch = useDispatch();

  const checkForCouponCode = () => {
    console.log("coupon_code", coupon_code);
    if (coupon_code) {
      setLoader(true);
      dispatch(checkCouponValidity(coupon_code));
      setLoader(false);
    } else {
      resetRes();
    }
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" && coupon_code) {
      checkForCouponCode();
    }
  };

  const resetRes = () => {
    dispatch(resetCouponCodeDetails());
    setCoupon_code("");
  };

  const handleChange = (e) => {
    setCoupon_code(e.target.value);
    const history = require("../../history").default;
    history.push({
      pathname: "/check-discount-coupon-validity",
      state: { discount_code: e.target.value },
    });
  };

  useEffect(() => {
    if (!coupon_code) {
      resetRes();
    }
  }, [coupon_code]);

  useEffect(() => {
    const selectedPropertyName = UserData.property?.property_name;
    const selectedDomainName = UserData.property?.domain;
    dispatch(SuperAdminAction.setDomainHeader(selectedPropertyName, selectedDomainName));
  }, [UserData]);

  useEffect(() => {
    resetRes();
    const discountCode = props.location?.state?.discount_code;
    if (discountCode) {
      setCoupon_code(discountCode);
      setLoader(true);
      dispatch(checkCouponValidity(discountCode));
      setLoader(false);
    }
  }, []);
  const showStartDate = (row) => (
    <>
      {row.startDate ? (
        <div className="text-currentTimerap text-truncate">
          {moment(row.startDate).format("DD-MM-YYYY")}
        </div>
      ) : (
        "-"
      )}
    </>
  );

  const showEndDate = (row) => (
    <>
      {row.endDate ? (
        <div className="text-currentTimerap text-truncate">
          {moment(row.endDate).format("DD-MM-YYYY")}
        </div>
      ) : (
        "-"
      )}
    </>
  );

  const discountType = {
    FIXED_COST: { prefix: "Fixed Cost", sufix: "$" },
    FIXED_DISCOUNT: { prefix: "Flat", sufix: "$ Off" },
    TIME_CREDIT: { prefix: "", sufix: "minutues Off" },
    PERCENTAGE: { prefix: "", sufix: "% Off" },
  };

  const discountToShow = useMemo(() => {
    const discountText = discountType[couponValidationDetail?.data?.discountType];
    return `${discountText?.prefix} ${couponValidationDetail?.data?.discountValue} ${discountText?.sufix}`;
  }, [couponValidationDetail]);

 const buildDiscountText = (type, value) => {

    const { prefix = "", sufix = "" } = discountType[type] ?? {};
    const parts = [prefix, value, sufix].filter(part => part);
    return parts.join(" ");
  };

  const normalizedInstances = useMemo(() => {
    const raw = couponValidationDetail?.data?.couponInstances || [];
    return raw.map((item) => {
      // Parse dates (unchanged)
      const startRaw = item["coupons.start_date"];
      const start = startRaw
        ? new Date(startRaw.replace(" ", "T")).toISOString()
        : null;
      const endRaw = item["coupons.expiry_date"];
      const end = endRaw
        ? new Date(endRaw).toISOString()
        : null;

      const ticketTitle = item["coupons.title"] || 'N/A';
      const parkingBenefit = item["coupons.line1"] || 'N/A';

      // Determine status based on backend fields
      let status = "Unknown";
      let statusColor = "gray";
      const currentTime = new Date();
      const startDate = start ? new Date(start) : null;
      const endDate = end ? new Date(end) : null;

      // Check if used FIRST (regardless of expiry date)
      let usedAt = null;
      // Check if used FIRST (regardless of expiry date)
      if (item.is_used) {
        const usedDate = item['used_at'] ? moment(item['used_at']).format("DD-MM-YYYY") : "";
        usedAt = item['used_at'] ? new Date(item['used_at']).toISOString() : null;
        status = `Used on ${usedDate}`;
        statusColor = "red";
      }
      // Current Date is between Start and End : Valid
      else if (startDate && endDate && currentTime >= startDate && currentTime <= endDate) {
        status = "Valid";
        statusColor = "green";
      }
      // Current Date < Start : Future
      else if (startDate && currentTime < startDate) {
        status = "Future";
        statusColor = "green";
      }
      // Current Date > End : Expired
      else if (endDate && currentTime > endDate) {
        status = "Expired";
        statusColor = "red";
      }
      // Default remains UnkcurrentTimen

      // Per-row merchant_code_* fields (post-refactor)
      const discountType = item.merchant_code_type || '';
      const discountValue = item.merchant_code_value ?? '';

      return {
        id: item.id,
        ticketTitle,
        parkingBenefit,
        startDate: start,
        endDate: end,
        discountText: buildDiscountText(discountType, discountValue),
        status,
        usedAt,
        statusColor,
      };
    }).sort((a, b) => {
      const aDate = a.usedAt || a.endDate;
      const bDate = b.usedAt || b.endDate;
      return new Date(bDate) - new Date(aDate);
    });
  }, [couponValidationDetail]);

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "120px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "120px",
      },
    },
  };

  const columns = useMemo(() => [
    {
      name: "Title",
      selector: (row) => row.ticketTitle,
      sortable: true,
      width: "270px",
    },
    {
      name: "Parking Benefit",
      selector: (row) => row.parkingBenefit,
      sortable: true,
      width: "250px",
    },
    {
      name: "Start Date",
      width: "250px",
      sortable: true,
      right: true,
      cell: (row) => showStartDate(row),
      selector: (row) => row.startDate || "-",
    },
    {
      name: "End Date",
      width: "220px",
      sortable: true,
      right: true,
      cell: (row) => showEndDate(row),
      selector: (row) => row.endDate || "-",
    },
    {
      name: "Discount",
      selector: (row) => row.discountText || "-",
      sortable: true,
      right: true,
      width: "260px",
      cell: (row) => (
        <div className="text-currentTimerap" style={{ textAlign: 'right' }}>
          {row.discountText || "-"}
        </div>
      ),
      selector: (row) => row.discountText || "",
    },
    {
      name: "Validity",
      selector: (row) => row.status,
      sortable: true,
      left: true,
      width: "300px",
      cell: (row) => (
        <span style={{
          color: row.statusColor,
        }}>
          {row.status}
        </span>
      ),
    }
  ], []);

  return (
    <>
      <Container fluid className="manage-unit-list-page page-no-fliter">
        <Row>
          <Col md="12">
            <Card className="mb-0">
              <Card.Header>
                <div className="d-flex align-items-center justify-content-between">
                  <Card.Title as="h4">Check Validity Of Parking Discount Coupon</Card.Title>
                </div>
              </Card.Header>
              <Card.Body style={{ minHeight: "80vh" }}>
                <Row className="mt-3">
                  <Col xl="6" lg="8" md="8" sm="12">
                    <label>Coupon Code</label>
                    <span className="asterisk">*</span>
                    <Form.Control
                      style={{ maxWidth: '250px' }}
                      placeholder="Enter Coupon Code"
                      type="text"
                      name="coupon_code"
                      value={coupon_code}
                      onChange={handleChange}
                      onKeyDown={onKeyDownHandler}
                      autoComplete="off"
                      required
                      maxLength={8}
                    ></Form.Control>
                  </Col>
                </Row>
                <Row>
                  <Col xl="6" lg="8" md="8" sm="12">
                    {loader ? (
                      <Spinner animation="border" variant="info" />
                    ) : (
                      <Button onClick={checkForCouponCode} disabled={!coupon_code} className="my-3 mr-3 alignItem:right">
                        Check Validity
                      </Button>
                    )}
                    <Button onClick={resetRes} disabled={loader} className="my-3 alignItem:right">
                      Reset
                    </Button>
                  </Col>
                </Row>
                <Row>
                  {!loader && (
                    <>
                      {couponValidationDetail?.message === "Incorrect coupon code" && (
                        <Col xl="6" lg="8" md="8" sm="12" className="mt-4">
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {couponValidationDetail?.message}
                          </div>
                        </Col>
                      )}
                      {couponValidationDetail?.data?.couponInstances?.length > 0 && (
                        <Col md="12">
                          <div className="mt-4">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <h5 className="mb-0">Coupon List</h5>
                            </div>
                            <div className="citation-list-table">
                              <DataTable
                                columns={columns}
                                data={normalizedInstances}
                                noHeader
                                pagination={false}
                                dense
                                highlightOnHover
                                persistTableHead
                                fixedHeader={false}
                                responsive={true}
                                customStyles={customStyles}
                              />
                            </div>
                          </div>
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CheckCouponValidity;
